<template>
  <div class="picker">
    <a-modal
      ref="modalRef"
      :visible="editorPopups.popupVisible(PopupType['bgColorPicker'])"
      :wrap-style="{ 'pointer-events': 'none', overflow: 'hidden' }"
      wrap-class-name="bgcolor-picker-popup"
      :width="276"
      :mask="false"
      :mask-closable="false"
      :footer="null"
      @cancel="editorPopups.togglePopup(PopupType['bgColorPicker'])"
    >
      <div ref="modalBodyRef"><canvas-bg-color-config /></div>
      <template #title>
        <div
          ref="modalTitleRef"
          class="absolute left-0 top-0 w-full h-full cursor-move flex items-center px-2 text-sm"
          style=""
        >
          视窗背景颜色
          <a-button
            v-if="
              editorStore.canvasBgColor.toUpperCase() !==
              defaultBg.toUpperCase()
            "
            type="text"
            size="small"
            class="ml-2 px-2 w-[auto] border-none bg-[transparent]"
            @click="() => (editorStore.canvasBgColor = defaultBg)"
            >重置</a-button
          >
        </div>
      </template>
      <template #modalRender="{ originVNode }">
        <div :style="transformStyle">
          <component :is="originVNode" />
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch, watchEffect } from 'vue';
import { PopupType, useEditorPopups } from '@/hooks/use-editor-popups';
const editorPopups = useEditorPopups();
import { useDraggable } from '@vueuse/core';
import { useEditorStore } from '@/store/use-editor-store';

const defaultBg = ref('#282828ff');
const modalTitleRef = ref<HTMLDivElement | null>(null);
const modalBodyRef = ref<HTMLDivElement | null>(null);
const { x, y, isDragging } = useDraggable(modalTitleRef);
const startX = ref(0);
const startY = ref(0);
const startedDrag = ref(false);
const transformX = ref(0);
const transformY = ref(0);
const preTransformX = ref(0);
const preTransformY = ref(0);
const dragRect = ref({
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
});
watch([x, y], () => {
  if (!modalTitleRef.value || !modalBodyRef.value) return;
  if (!startedDrag.value) {
    startX.value = x.value;
    startY.value = y.value;
    const bodyRect = document.body.getBoundingClientRect();
    const modalTitleRect = modalTitleRef.value.getBoundingClientRect();
    const modalBodyRect = modalBodyRef.value.getBoundingClientRect();
    dragRect.value.right = bodyRect.width - modalTitleRect.width;
    dragRect.value.bottom =
      bodyRect.height - (modalTitleRect.height + modalBodyRect.height);
    preTransformX.value = transformX.value;
    preTransformY.value = transformY.value;
  }
  startedDrag.value = true;
});
watch(isDragging, () => {
  if (!isDragging) {
    startedDrag.value = false;
  }
});
watchEffect(() => {
  if (startedDrag.value) {
    transformX.value =
      preTransformX.value +
      Math.min(Math.max(dragRect.value.left, x.value), dragRect.value.right) -
      startX.value;
    transformY.value =
      preTransformY.value +
      Math.min(Math.max(dragRect.value.top, y.value), dragRect.value.bottom) -
      startY.value;
    transformY.value = Math.max(-60, transformY.value);
  }
});
const transformStyle = computed(() => {
  return {
    transform: `translate(${transformX.value}px, ${transformY.value}px)`
  };
});
const editorStore = useEditorStore();
</script>
<style lang="less">
.bgcolor-picker-popup {
  .ant-modal-content {
    border-radius: 10px !important;
    background-color: #000000;
    .ant-modal-header {
      height: 2rem !important;
      padding: 0.5rem;
      position: relative;
      border-radius: 10px 10px 0 0;
      background-color: #000000;
      .ant-modal-title {
        font-size: 0;
      }
    }
    .ant-modal-body {
      padding: 0;
    }
    .ant-modal-close-x {
      width: 0 !important;
      height: 0 !important;
      transform: translate(-16px, 16px) !important;
    }
  }
}
</style>
